<template>
  <transition name="fade">
    <b-card no-body class="w-100">
      <div slot="header" class="header">
        <div>{{ title }} (total: {{ totalItems }})</div>
        <div class="card-header-actions">
          <div v-if="exportTypes && csvAccess">
            <b-button
              v-for="(exportType, index) in exportTypes"
              @click="$emit('export', exportType)"
              :key="`type-${index}`"
              variant="primary"
              size="sm"
              class="download-button">
              {{ exportType.toUpperCase() }}
            </b-button>
          </div>
        </div>
      </div>

      <b-card-body class="card-content">
        <c-table
          class="h-100"
          :table-data="itemsFormatted"
          :fields="columns"
          :sorting="sorting"
          :striped="true"
          :bordered="false"
          :small="false"
          :perPage="10"
          :currentPageExternal="currentPage"
          @page-changed="pageChanged"
          caption="">
        </c-table>
      </b-card-body>
    </b-card>
  </transition>
</template>

<script>
import cTable from '../Table.vue'
import { mapActions } from 'vuex'
import moment from 'moment'
import { formatFloat } from '../../shared/number-utils'

export default {
  name: 'drydock-stays',

  components: {
    cTable
  },

  props: {
    title: {
      type: String,
      default: 'Port calls',
    },

    items: {
      type: Array,
      default: () => []
    },

    currentPage: {
      type: Number,
      default: () => 1
    },

    sorting: {
      type: Boolean,
      default: false,
    },

    exportTypes: {
      type: Array,
      default: () => null
    }
  },

  data() {
    return {
      columns: [
        { key: 'IMO', sortable: true },
        { key: 'vesselName', sortable: true },
        { key: 'countryCode', sortable: true },
        { key: 'portId', sortable: true },
        { key: 'portName', sortable: true },
        { key: 'portUnlocode', sortable: true },
        { key: 'shipyardId', sortable: true },
        { key: 'shipyardName', sortable: true },
        { key: 'shipyardStayId', sortable: true },
        { key: 'durationDays', sortable: true },
        { key: 'dwt', sortable: true },
        { key: 'region', sortable: true },
        { key: 'segment', sortable: true },
        { key: 'subsegment', sortable: true },
        { key: 'arrivedAt', sortable: true },
        { key: 'departedAt', sortable: true },
        { key: 'updatedAt', sortable: true },
      ],

      csvAccess: false
    };
  },

  async mounted() {
    await this.getUserData();
  },

  methods: {
    ...mapActions('api', ['getUser']),

    async getUserData() {
      let user = await this.getUser();
      this.csvAccess =
        user[
          'https://app.oceanbolt.com/user_authorization'
        ].permissions.includes('download:csv') || false;
    },

    pageChanged(currentPage, totalPages) {
      // we have to emit 2 events since we have 3 level in components: TradeFlows -> Voyages -> Table
      // data came from 'Tradeflows' so current/total page must be available there
      this.$emit('page-changed', currentPage, totalPages);
    },
  },
  computed: {
    itemsFormatted() {
      return this.items.map(item => {
        let formattedItem = {};
        this.columns.forEach(field => {
          if (field.key === 'IMO') {
            formattedItem[field.key] = item['imo'];
          } else if (field.key === 'arrivedAt' || field.key === 'departedAt' || field.key === 'updatedAt') {
            formattedItem[field.key] = item[field.key] ? moment(item[field.key]).format("YYYY-MM-DD @ HH:mm") : "-";
          } else if(field.key === 'durationDays') {
            formattedItem[field.key] = formatFloat(item[field.key]);
          } else {
            formattedItem[field.key] = item[field.key];
          }
        });
        return formattedItem;
      });
    },

    totalItems() {
      return this.items.length;
    }
  }
};
</script>

<style scoped lang="scss">
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;

  .card-header-actions {
    display: flex;
  }
}
</style>
